import { render, staticRenderFns } from "./credential-generate-user-component.vue?vue&type=template&id=315fc150&scoped=true&"
import script from "./credential-generate-user-component.vue?vue&type=script&lang=js&"
export * from "./credential-generate-user-component.vue?vue&type=script&lang=js&"
import style0 from "./credential-generate-user-component.vue?vue&type=style&index=0&id=315fc150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315fc150",
  null
  
)

export default component.exports